(function($) {
  $(function() {

    // if any of the defined elements are clicked, run toggleSection function
    $('.accordion').click(function() {window.shopUtils.toggleSection(this);});
    $('.accordion-expand-all, .accordion-collapse-all').click(function() {window.shopUtils.toggleAllSections(this);});

  });
})(jQuery);